import { REFRESH_TOKEN_KEY, TOKEN_KEY } from '@/api/index';

/**
 * Persist the auth token pair to localStorage.
 */
export const storeAuthTokens = (tokens: {
  token: string;
  refreshToken: string;
}) => {
  localStorage.setItem(TOKEN_KEY, tokens.token);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
};
